import { useEffect } from 'react'

export function DocumentTitle({ title }: { title?: string }) {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Find That Line`
    } else {
      document.title = 'Find That Line'
    }
  }, [title])

  return null
}
